// Layer 1 — one-off assignments — docs/real-estate/be/
// 10-api-reference.md §A10.
import { request } from './http';

// `query`: { agent_id?, property_id?, from_date?, to_date?, page?, page_size? }.
export function listAssignments(query) {
  return request({
    path: '/properties/agent-specific-assignments',
    params: query,
  });
}

// `body`: { property_id, agent_id, start_date, end_date, time_slots? }.
export function createAssignment(body) {
  return request({
    method: 'post',
    path: '/properties/agent-specific-assignments',
    data: body,
  });
}

// Used by the agent calendar (§A11) to load the full date range/time_slots
// before opening AssignmentModal in edit mode — the calendar's own day
// entries only carry that one day's already-resolved slots, not the
// assignment's whole record.
export function getAssignment(assignmentId) {
  return request({
    path: `/properties/agent-specific-assignments/${assignmentId}`,
  });
}

// Accepts any subset of { start_date, end_date, time_slots } — sending
// time_slots replaces all of them.
export function patchAssignment(assignmentId, fields) {
  return request({
    method: 'patch',
    path: `/properties/agent-specific-assignments/${assignmentId}`,
    data: fields,
  });
}

export function deleteAssignment(assignmentId) {
  return request({
    method: 'delete',
    path: `/properties/agent-specific-assignments/${assignmentId}`,
  });
}
